import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';

import BasicButton from '@/ui-components/BasicButton.vue';

import StreamGreenSurvey from './StreamGreenSurvey.vue';
import StreamGreenUpload from './StreamGreenUpload.vue';
import Spinner from '@/ui-components/Spinner.vue';

import { WebLocale } from '@/enums/web-locale';

import type { FootprintParams } from './types';
import { storeToRefs } from 'pinia';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';

type Steps = 'intro' | 'results';


export default /*#__PURE__*/_defineComponent({
  __name: 'StreamGreen',
  setup(__props) {

const StreamGreenResults = () => import(/* webpackChunkName: "stream-green-results" */ './StreamGreenResults.vue');

const { webLocale } = storeToRefs(useLanguageStore());

const step = ref<Steps>('intro');
const resultFootprint = ref(0);
const resultEpisodes = ref<number | undefined>();
const resultMovies = ref<number | undefined>();
const resultStartDatetime = ref<number | undefined>();
const isLoading = ref(false);
const showSurvey = ref(false);

const regions = {
	[WebLocale.de]: 0.276,
	[WebLocale.us]: 0.493,
};
/**
 * regions produce different amount of CO2.
 * documented in this sheet: https://docs.google.com/document/d/1gFA7Sa2is9XX6tY1b3MyWbaKx6V5GP-vHk24w9CiPaw/edit
 */
const regionFactor = computed(() => regions[webLocale.value as keyof typeof regions] ?? 0.519);

const includeSurvey = computed(() => webLocale.value === WebLocale.us || webLocale.value === WebLocale.de);

async function goToStep(localStep: Steps) {
	setTimeout(() => window.scroll({ top: 0, behavior: 'smooth' }), 250);

	if (localStep === 'results') {
		// if the transition leads to result page add a loading spinner inbetween.
		isLoading.value = true;
		await new Promise(resolve => setTimeout(resolve, 1200));
	}
	step.value = localStep;
	isLoading.value = false;
}

/**
 * providers produce different amount of CO2.
 * documented in this sheet: https://docs.google.com/document/d/1gFA7Sa2is9XX6tY1b3MyWbaKx6V5GP-vHk24w9CiPaw/edit
 */
const providersFactor = {
	netflix: 1.2,
	hbonow: 1.2,
	hbogo: 1.2,
	hulu: 1.6,
	skyticket: 0.6,
};
function calculateFootprint(params: FootprintParams) {
	const localRegionFactor = regionFactor.value;
	const localProviderFactor = params.selectedProviders.reduce((root, provider, index, array) => {
		const value = provider in providersFactor ? (providersFactor as any)[provider] : 1;
		return root + value / array.length;
	}, 0);

	resultFootprint.value = Number(((params.yearlyKwh * localRegionFactor * localProviderFactor) / 1000).toFixed(2));
	resultEpisodes.value = params.amountEpisodes;
	resultMovies.value = params.amountMovies;
	resultStartDatetime.value = params.startDatetime;
	goToStep('results');
}

return { __sfc: true,StreamGreenResults, webLocale, step, resultFootprint, resultEpisodes, resultMovies, resultStartDatetime, isLoading, showSurvey, regions, regionFactor, includeSurvey, goToStep, providersFactor, calculateFootprint, BasicButton, StreamGreenSurvey, StreamGreenUpload, Spinner }
}

})